export const FILTER_MODE = {
  DNI: 'dni',
  POLICY: 'policy',
  LOAD_ID: 'loadId'
} as const;

export type FilterMode = (typeof FILTER_MODE)[keyof typeof FILTER_MODE];
